import { getRatioSelection, OneDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (colArr, colIdx: number): number => {
  return colArr[colIdx].quarters.reduce((acc, quarter) => {
    acc += quarter.months.length;
    return acc;
  }, 0) + 1;
};

export const calculateMeasureTotal = (rowArr, rIdx: number, mIdx: number, measureGroup: string, measureName: string): number => {
  // if (['ASP Actual $', 'Plan ASP $'].indexOf(measureName) !== -1) {
  if (measureName === 'ASP Actual $') {
    const qtrLength = rowArr[rIdx].measures[mIdx].quarters.length;
    const measureTotal = calculateMeasureTotalBasedOnQuarterAvg(rowArr[rIdx].measures[mIdx].quarters);

    return Math.round(measureTotal / qtrLength);
  }

  if (measureName === 'Plan ASP $') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    const planQuotaUnit = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[planQuotaIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planSalesIdx].quarters);

    if (planQuotaUnit === 0) {
      return 0;
    }

    return Math.round(planQuotaValue / planQuotaUnit);
  }

  if (measureName === 'PL vs LY U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals U');
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lyValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyIdx].quarters);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals U');
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lqValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqIdx].quarters);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'PL vs LY $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals $');
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lyValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyIdx].quarters);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals $');
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lqValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqIdx].quarters);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters);

    if (planQuotaValue === 0) {
      return 0;
    }

    return OneDecimalPlace((marginValue / planQuotaValue) * 100);
  }

  if (measureName === 'LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');
    const lqMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqMarginIdx].quarters);
    const lqActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lqActualIdx].quarters);

    if (lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace((lqMarginValue / lqActualValue) * 100);
  }

  if (measureName === 'LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');
    const lyMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyMarginIdx].quarters);
    const lyActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lyActualIdx].quarters);

    if (lyActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace((lyMarginValue / lyActualValue) * 100);
  }

  if (measureName === 'PL vs LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');
    const lqMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqMarginIdx].quarters);
    const lqActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lqActualIdx].quarters);

    const lqMarginPctValue = Math.round((lqMarginValue / lqActualValue) * 100);

    if (planQuotaValue === 0 || lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  if (measureName === 'PL vs LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');
    const lyMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyMarginIdx].quarters);
    const lyActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lyActualIdx].quarters);

    const lqMarginPctValue = Math.round((lyMarginValue / lyActualValue) * 100);

    if (planQuotaValue === 0 || lyActualValue === 0) {
      return 0;
    }
    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  return calculateActualMeasureTotal(rowArr[rIdx].measures[mIdx].quarters);
};

export const calculateActualMeasureTotal = (quarterArr): number => {
  return quarterArr.reduce((qInit, quarter) => {
    qInit += quarter.months.reduce((mInit, month) => {
      mInit += month.value;
      return mInit;
    }, 0);
    return qInit;
  }, 0);
};

export const calculateMeasureTotalBasedOnQuarterAvg = (quarterArr): number => {
  const arr: number[] = [];
  quarterArr.reduce((qInit, quarter) => {
    qInit = quarter.months.reduce((mInit, month) => {
      mInit += month.value;
      return mInit;
    }, 0);

    arr.push(qInit / quarter.months.length);
    return qInit;
  }, 0);

  return arr.reduce((acc, value) => {
    acc += value;
    return acc;
  }, 0);
};

export const calculateQuarterTotal = (rowArr, rIdx: number, mIdx: number, qIdx: number, measureGroup: string, measureName: string): number => {
  //if (['ASP Actual $', 'Plan ASP $'].indexOf(measureName) !== -1) {
  if (measureName === 'ASP Actual $') {
    const qtrLength = rowArr[rIdx].measures[mIdx].quarters[qIdx].months.length;
    const measureTotal = calculateActualQuarterTotal(rowArr[rIdx].measures[mIdx].quarters[qIdx].months);

    return Math.round(measureTotal / qtrLength);
  }

  if (measureName === 'Plan ASP $') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    const planQuotaUnit = calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[planQuotaIdx].quarters[qIdx].months);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planSalesIdx].quarters[qIdx].months);

    if (planQuotaUnit === 0) {
      return 0;
    }

    return Math.round(planQuotaValue / planQuotaUnit);
  }

  if (measureName === 'PL vs LY U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals U');
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].months);
    const lyValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyIdx].quarters[qIdx].months);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals U');
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].months);
    const lqValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqIdx].quarters[qIdx].months);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'PL vs LY $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals $');
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].months);
    const lyValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyIdx].quarters[qIdx].months);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals $');
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].months);
    const lqValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqIdx].quarters[qIdx].months);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].months);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].months);


    if (planQuotaValue === 0) {
      return 0;
    }
    return OneDecimalPlace((marginValue / planQuotaValue) * 100);
  }

  if (measureName === 'LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');
    const lqMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqMarginIdx].quarters[qIdx].months);
    const lqActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lqActualIdx].quarters[qIdx].months);

    if (lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace((lqMarginValue / lqActualValue) * 100);
  }

  if (measureName === 'LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');
    const lyMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyMarginIdx].quarters[qIdx].months);
    const lyActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lyActualIdx].quarters[qIdx].months);

    if (lyActualValue === 0) {
      return 0;
    }
    return OneDecimalPlace((lyMarginValue / lyActualValue) * 100);
  }

  if (measureName === 'PL vs LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].months);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].months);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');
    const lqMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqMarginIdx].quarters[qIdx].months);
    const lqActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lqActualIdx].quarters[qIdx].months);

    const lqMarginPctValue = Math.round((lqMarginValue / lqActualValue) * 100);

    if (planQuotaValue === 0 || lqActualValue === 0) {
      return 0;
    }
    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  if (measureName === 'PL vs LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const marginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].months);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].months);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');
    const lyMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyMarginIdx].quarters[qIdx].months);
    const lyActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lyActualIdx].quarters[qIdx].months);

    const lqMarginPctValue = Math.round((lyMarginValue / lyActualValue) * 100);

    if (planQuotaValue === 0 || lyActualValue === 0) {
      return 0;
    }
    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  return calculateActualQuarterTotal(rowArr[rIdx].measures[mIdx].quarters[qIdx].months);
};

export const calculateActualQuarterTotal = (monthArr): number => {
  return monthArr.reduce((mInit, month) => {
    mInit += month.value;
    return mInit;
  }, 0);
};

export const checkIfAllQuartersArePast = (quarters): boolean => {
  return quarters.reduce((acc, value) => acc && value.isPast, true);
};

export const getRatioSelectionOfPlanningGridForMonth = (
  rowArr: any[],
  qIdx: number,
  mIdx: number,
  oldVal,
): string => {
  const unitIdx = rowArr.findIndex(row => row.name === 'UNITS');
  const forecastUnitIdx = rowArr[unitIdx].measures
    .findIndex(measure => measure.name === 'Forecast Unconstrained U');
  const lyUnitIdx = rowArr[unitIdx].measures
    .findIndex(measure => measure.name === 'LY - Actuals U');
  const forecastVal = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].months[mIdx].value;
  const lyVal = rowArr[unitIdx].measures[lyUnitIdx].quarters[qIdx].months[mIdx].value;

  const monthLength = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].months.length;
  const isValidForecast = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].months[monthLength - 1].value > 0;

  return getRatioSelection(oldVal, forecastVal, lyVal, isValidForecast);
};
